import { store } from 'index'
import * as REDUX_TYPES from '../types'
const ACCOUNT_STORAGE = 'account'
const ACCESS_TOKEN_STORAGE = 'accessToken'
/**
 * OK bummer but because of inconsistent use of the id field in accountReducer 
 * versus the _id field in the account (aka User) instance returned from the server
 * we need to check for both when we want the account id used in this client.
 * 
 * @todo Clean up inconsistency with account id and _id
 * @param {*}  return0  Return a 0 instead of null if there is no account or id or _id
 * @returns 
 */
export const getAccountId = (return0) => {
  const account = getStorageAccount()
  if (account) {
    const { _id, id } = account
    if (id) {
      return id
    } else if (_id) {
      return _id
    }
  }
  return return0 ? 0 : null
}

export const getStorageAccount = () => {
  const acct = localStorage.getItem(ACCOUNT_STORAGE)
  if (acct) {
    const parsedAccount = JSON.parse(acct)
    return parsedAccount
  } else {
    return null
  }
}

/**
 * Convenience method that assumes the presence of a stored account
 * means we are signed in.
 * @returns true if there is a stored account, false otherwise
 */
export const isSignedIn = () => {
  const { signedIn } = store.getState().account
  return signedIn
}

/**
 * See if the signed-in user is the one and only "support" uiser.
 * @returns 
 */
export const isSupportUser = () => {
  if (isSignedIn()) {
    const { handle } = getStorageAccount()
    return handle === 'support'
  } else {
    return false
  }
}
/**
 * This *only* works when using localhost.
 * @returns 
 */
export const getStorageAccessToken = () => {
  return localStorage.getItem(ACCESS_TOKEN_STORAGE)
}

/**
 * Save the accessToken received from the Core Service into localStorage
 * @todo Use secure httpOnly cookie instead
 * @param {*} accessToken 
 */
export const setAccessToken = (accessToken) => {
  console.log(`setAccessToken ${accessToken}`)
  if (accessToken) {
    localStorage.setItem(ACCESS_TOKEN_STORAGE, accessToken)
  } else {
    localStorage.removeItem(ACCESS_TOKEN_STORAGE)
  }
}

/**
 * @param {*} account 
 */
export const setAccount = (account) => {
  if (account) {
    delete account.accessToken
    localStorage.setItem(ACCOUNT_STORAGE, JSON.stringify(account))
  } else {
    localStorage.removeItem(ACCOUNT_STORAGE)
  }
}

export const resetAccount = () => {
  return {
    type: REDUX_TYPES.ACCOUNT.RESET,
  }
}

export const setEmailConfirmation = (emailConfirmation) => {
  return {
    type: REDUX_TYPES.ACCOUNT.EMAIL_CONFIRMATION,
    emailConfirmation,
  }
}
export const setEthAccount = (ethAccount) => {
  return {
    type: REDUX_TYPES.ACCOUNT.ETH,
    ethAccount,
  }
}
export const setIsArtist = (isArtist) => {
  return {
    type: REDUX_TYPES.ACCOUNT.IS_ARTIST,
    isArtist,
  }
}

export const setSignedIn = (signedIn) => {
  return {
    type: REDUX_TYPES.ACCOUNT.SIGNED_IN,
    signedIn,
  }
}

export const setStudios = (studios) => {
  return {
    type: REDUX_TYPES.ACCOUNT.STUDIOS,
    studios,
  }
}

export const setSubscribedStudios = (subscribedStudios) => {
  return {
    type: REDUX_TYPES.ACCOUNT.SUBSCRIBED_STUDIOS,
    subscribedStudios,
  }
}


